export default __webpack_public_path__ + "static/media/BodoniModa_7pt-ExtraBold.15c227c9.ttf";